
import {
  Component,
  Prop,
  Mixins,
  Emit,
} from 'vue-property-decorator';
import {
  Dialog,
  Form,
  FormItem,
  Input,
  InputNumber,
  Select,
  Option,
  Button,
  Upload,
  Radio,
} from 'element-ui';
import { ISetting } from '@/types/set.d';
import api from '@/api/set';
import publicApi from '@/api/public';
import FormMixin from './formMixin';

@Component({
  components: {
    Dialog,
    Form,
    FormItem,
    Input,
    InputNumber,
    Select,
    Option,
    Button,
    Upload,
    Radio,
  },
})
export default class ManageBusModal extends Mixins(FormMixin) {
  @Prop({
    required: true,
    default: false,
  }) visible!: boolean;

  @Prop({
    required: false,
    default: '添加配置',
  }) title!: string;

  @Prop({
    required: false,
  }) oldForm!: any;

  @Prop({
    required: false,
  }) typeList!: any;

  @Prop({
    required: false,
  }) isShowSelectOpt!: boolean;

  @Prop({
    required: false,
  }) showDiffi!: boolean;

  private initType: string = '';

  private status: any = [{ label: '是', value: 0 }, { label: '否', value: 1 }];

  private fileListImg: any = [];

  private diffculites: any = [];

  mounted() {
    publicApi.getType('difficulty').then((result: any) => {
      this.diffculites = result;
    });
    if (this.title.includes('编辑')) {
      this.form = {
        pid: this.oldForm.pid,
        title: this.oldForm.title,
        visible: this.oldForm.visible,
        sort: this.oldForm.sort,
        effectiveStatus: this.oldForm.effectiveStatus,
      };
      if (this.oldForm.iconPath) this.fileListImg = [{ url: this.oldForm.iconPath }];
      if (this.oldForm.type === 'knowledge') this.form.remark = this.oldForm.remark;
    }
    if (this.form.sort === undefined) {
      this.form.sort = 0;
    }
  }

  /**
   * @author lianguongmou
   * @desc 图片上传前事件
    */
  handleBeforeUpload(file: File) {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (e:any) => {
      this.fileListImg = [{ url: e.target.result }];
    };
    this.form.iconFile = file;
    return false;
  }

  /**
   * @author liangyongmou
   * @desc 主图片删除事件
   * @params { any } file 文件
   */
  handleBeforeRemove(file: any) {
    if (file.status === 'success') this.form.stepImage = '';
  }

  // 重置表单
  reset(close: boolean = false, refrsh: boolean = false) {
    if (close) this.$emit('update:visible', false);
    if (refrsh) this.$emit('refrsh');
    this.$log({
      title: `${this.log.name}${close ? '关闭' : '重置'}`,
      component: this.log.component,
    });
    this.resetForm();
  }

  /**
   * @author liangyongmou
   * @desc 添加/编辑机构信息
   * @param { string } title 标题
   */
  submit(title: string) {
    this.loading = true;
    this.$refs.form.validate((valid: boolean) => {
      if (valid) {
        this.$log({
          title: `${this.log.name}提交`,
          component: this.log.component,
        });
        const data = new FormData();
        Object.keys(this.form).forEach((index) => {
          if ((this.form[index] || this.form[index] === 0) && (index !== 'initType')) data.append(index, this.form[index]);
        });
        if (title.includes('编辑')) {
          api.editCon(data, this.oldForm.type).then(() => {
            this.reset(true, true);
            this.loading = false;
          /* eslint-disable no-return-assign */
          }).catch(() => (this.loading = false));
        } else {
          api.addCon(data, this.initType).then(() => {
            this.reset(true, true);
            this.loading = false;
          /* eslint-disable no-return-assign */
          }).catch(() => (this.loading = false));
        }
      } else this.loading = false;
    });
  }

  selectType(addType: string) {
    this.initType = this.form.initType;
    this.$emit('bindGetType', addType);
  }
}
